module.exports = __webpack_public_path__ + "img/why-select-us.2acf921e.png";